import React from 'react';
import { TextField as MuiTextField, MenuItem } from '@mui/material';
import type { Select as Interface } from '../../design/components';

export const Select: React.FC<Interface> = ({
  name, description, state, placeholder, hidden, inline, readonly, disabled, required,
  error, options = [], clearable
}) => {
  const [value, setValue] = state || ['', () => {}];

  // Inline mode: render the selected option's label or value as text
  if (inline) {
    const selected = options.find(opt => opt.state?.[0] === value);
    return (
      <span style={{ display: hidden ? 'none' : undefined }}>
        {selected?.label || value || ''}
      </span>
    );
  }

  const aria: Record<string, unknown> = {};
  if (required) aria['aria-required'] = true;
  if (readonly) aria['aria-readonly'] = true;
  if (disabled) aria['aria-disabled'] = true;
  if (error) {
    aria['aria-invalid'] = true;
    aria['aria-errormessage'] = `${name}-error`;
  }

  return (
    <MuiTextField
      id={name}
      name={name}
      label={name}
      helperText={error || description}
      value={value ?? ''}
      placeholder={placeholder}
      onChange={(e) => setValue(e.target.value)}
      error={!!error}
      disabled={disabled}
      required={required}
      select
      fullWidth
      slotProps={{
        input: { readOnly: readonly },
        htmlInput: { ...aria },
      }}
      sx={{ display: hidden ? 'none' : undefined }}
    >
      {clearable && <MenuItem value="">{placeholder || <em>None</em>}</MenuItem>}
      {options.map(opt => {
        const optValue = opt.state?.[0] as string;
        return (
          <MenuItem key={optValue} value={optValue}>
            {opt.label || optValue}
          </MenuItem>
        );
      })}
    </MuiTextField>
  );
};
